import { createTheme } from '@one-thd/sui-atomic-components';

const MothersDayPrimaryOne = createTheme({
  palette: {
    mode: 'light',
    background: {
      primary: 'brand'
    }
  }
});

MothersDayPrimaryOne.palette['--sui-palette-background-primary'] = '246 243 239';

export { MothersDayPrimaryOne };
